import Badge from 'components/base/Badge';
import dayjs from 'dayjs';
import React from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

function CandidateSkillCard() {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    (user.info?.skills || user.info?.education) && (
      <Card className="h-100">
        <Card.Body>
          {user.info?.skills && (
            <div className="border-bottom mb-4">
              <h5>Skills</h5>
              <div className="py-3">
                {user.info.skills.map(({ skill }, index: number) => (
                  <Badge
                    bg="secondary"
                    variant="phoenix"
                    iconPosition="end"
                    className="fs-10 me-2"
                    key={index}
                  >
                    {skill}
                  </Badge>
                ))}
              </div>
            </div>
          )}
          {user.info?.education && (
            <div>
              <h5 className="mb-3">Education</h5>
              {user.info.education.map(
                ({ college, degree, startDate, endDate }, index: number) => (
                  <div className="mb-2" key={index}>
                    <small>
                      {dayjs(startDate).format('MMMM YYYY')} -{' '}
                      {dayjs(endDate).format('MMMM YYYY')}
                    </small>
                    <h5>{college}</h5>
                    <p>{degree}</p>
                  </div>
                )
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    )
  );
}

export default CandidateSkillCard;
